import { FadeUp } from "@/components/Reveal";
import { IMAGES } from "@/data/content";

export const DressAttire = () => {
  return (
    <section
      id="attire"
      data-testid="attire-section"
      className="section-pad relative"
    >
      <div className="max-w-[1300px] mx-auto grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        <FadeUp className="md:col-span-5 md:order-2">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.attire}
              alt="Smart casual attire"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
          </div>
        </FadeUp>

        <FadeUp delay={0.1} className="md:col-span-7 md:order-1">
          <div className="eyebrow-line">Dress Code</div>
          <h2
            className="font-serif-display text-[#FDFBF7] mt-6 leading-[1.05]"
            style={{ fontSize: "clamp(36px, 5vw, 56px)" }}
          >
            Smart casual.{" "}
            <span className="italic text-[#D4AF37]">Come comfortable.</span>
          </h2>
          <p className="mt-8 text-[#FDFBF7]/85 text-lg leading-[1.75] max-w-[58ch] font-light">
            This is a dinner, not a ball. Think a nice button-down, a polo, a
            blouse, a sweater that fits you well — something you feel good in.
            Skip the suit and tie; skip the gym shorts. The room is candle-lit
            and warm, the music is on, and I want you here comfortable, not
            stiff.
          </p>
          <ul className="mt-10 space-y-5 max-w-[56ch]">
            {[
              ["Gentlemen", "Button-down or polo, dark jeans or chinos, clean shoes or loafers. No tie required."],
              ["Ladies", "Blouse, sweater, slacks, a midi dress, or a jumpsuit — whatever feels like you."],
              ["Footwear", "Clean and considered. No sneakers, athletic wear, or flip-flops, please."],
              ["Outerwear", "Coat check available. The room is candle-warm, but Chicago June nights can cool off."],
            ].map(([k, v]) => (
              <li key={k} className="grid grid-cols-12 gap-4 items-baseline">
                <span className="col-span-4 md:col-span-3 overline">{k}</span>
                <span className="col-span-8 md:col-span-9 text-[#FDFBF7]/85 text-base md:text-lg leading-[1.6]">
                  {v}
                </span>
              </li>
            ))}
          </ul>
        </FadeUp>
      </div>
    </section>
  );
};
